const innitialState = {}

export default (state = innitialState, action) => {
  switch (action.type) {
    case 'INSERT_MOBILE_RECHARGE':
      return innitialState
    case 'SHOW_ERRORMESSAGE_RECHARGE':
      return { ...state, errorMessage: action.message }
    case 'CLEAR_ERROR_MESSAGE':
      return { ...state, errorMessage: undefined }
    case 'MOBILE_RECHARGE_FINALIZE_ORDER':
      return { ...state, loadingFinalizeOrder: true }
    case 'MOBILE_RECHARGE_FINALIZE_ORDER_END':
      return { ...state, loadingFinalizeOrder: undefined }
    case 'MOBILE_RECHARGE_FINALIZE_ORDER_SUCCESS':
      return { ...state, mobileRechargeInserted: true }
    case 'MOBILE_RECHARGE_SCHEDULE_ORDER':
      return { ...state, loadingScheduleOrder: true }
    case 'MOBILE_RECHARGE_SCHEDULE_ORDER_END':
      return { ...state, loadingScheduleOrder: undefined }
    case 'SECOND_FACTOR_AUTHENTICATION':
      return {
        ...state,
        secondFactorAuthentication: true,
        secondFactorAuthenticationOrderId: action.orderId,
        secondFactorAuthConfirmated: action.secondFactorAuthConfirmated,
        phone: action.phone
      }
    case 'CLOSE_SECOND_FACTOR':
      return {
        ...state,
        secondFactorAuthentication: undefined,
        secondFactorAuthenticationOrderId: undefined
      }
    case 'RESET_DATA':
      return innitialState
    default:
      return state || innitialState
  }
}



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/reducer.js